import './App.css';
import About from './compoents/about';
import Facilities from './compoents/facilities';
import Gallery from './compoents/gallery';
import Nav from './compoents/nav';
import NearbyAttract from './compoents/nearbyattractions';
import Room from './compoents/room';
import Slider from './compoents/slider';
import WeddingLawnAndConferenceHall from './compoents/weddinglawnandconferencehall';
import Location from './compoents/location';
import Testimonials from './compoents/testimonials';
import Contact from './compoents/contact';
import Footer from './compoents/footer';
import NearbyCities from './compoents/nearby-cities';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    // ✅ Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', e => {
        e.preventDefault();
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // ✅ Navbar background change on scroll
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        navbar.style.background =
          window.scrollY > 50 ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 0, 0, 0.8)';
      }
    };
    window.addEventListener('scroll', handleScroll);

    // ✅ Parallax disable for mobile
    if (window.innerWidth <= 768) {
      document.querySelectorAll('.parallax-section').forEach(section => {
        section.style.backgroundAttachment = 'scroll';
      });
    }

    // ✅ Scroll animation observer
    const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('fade-in-up');
      });
    }, observerOptions);

    document.querySelectorAll('.card, .testimonial-card, .amenity-icon, .stagger-animation, .fade-in-left, .fade-in-right, .fade-in-scale, .float, .pulse')
      .forEach(el => observer.observe(el));

    // ✅ Section observer for staggered animations
    const sectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
          const staggerElements = entry.target.querySelectorAll('.stagger-animation');
          staggerElements.forEach((el, index) => {
            setTimeout(() => {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            }, index * 200);
          });
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('section').forEach(section => {
      sectionObserver.observe(section);
    });

    // ✅ Video background logic
    const heroVideo = document.querySelector('.hero-video');
    const videoLoading = document.getElementById('videoLoading');
    if (videoLoading) videoLoading.style.display = 'none';

    if (heroVideo) {
      heroVideo.style.display = 'none';

      heroVideo.addEventListener('loadeddata', () => {
        heroVideo.style.display = 'block';
        heroVideo.style.opacity = '1';
      });

      heroVideo.play().catch(error => {
        console.log('Video autoplay failed:', error);
        heroVideo.style.display = 'none';
      });

      heroVideo.addEventListener('error', e => {
        console.log('Video error:', e);
        heroVideo.style.display = 'none';
      });

      setTimeout(() => {
        if (heroVideo.readyState === 0) {
          console.log('Video failed due to CORS or network issues');
          heroVideo.style.display = 'none';
        }
      }, 2000);
    }

    // ✅ Gallery carousel filtering
    const carousel = document.querySelector('#galleryCarousel');
    const filterButtons = document.querySelectorAll('[data-filter]');
    const carouselItems = document.querySelectorAll('.carousel-item');

    if (carousel && window.bootstrap) {
      const carouselInstance = new window.bootstrap.Carousel(carousel);
      const indicators = document.querySelectorAll('.carousel-indicators button');

      filterButtons.forEach(button => {
        button.addEventListener('click', () => {
          filterButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
          const filter = button.getAttribute('data-filter');
          let visibleItems = [];

          carouselItems.forEach((item, index) => {
            if (filter === 'all' || item.getAttribute('data-category') === filter) {
              item.style.display = 'block';
              visibleItems.push(index);
            } else {
              item.style.display = 'none';
            }
          });

          indicators.forEach((indicator, index) => {
            indicator.style.display =
              filter === 'all' || carouselItems[index].getAttribute('data-category') === filter
                ? 'block'
                : 'none';
          });

          if (visibleItems.length > 0) carouselInstance.to(visibleItems[0]);
        });
      });
    }

    // ✅ About carousel auto-start
    const aboutCarouselEl = document.querySelector('#aboutCarousel');
    if (aboutCarouselEl && window.bootstrap) {
      const aboutCarouselInstance = new window.bootstrap.Carousel(aboutCarouselEl, {
        interval: 1500,
        ride: 'carousel',
        pause: false,
        wrap: true,
        touch: true,
      });
      aboutCarouselInstance.cycle();
    }

    // 🧹 Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
      sectionObserver.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <Nav />
      <Slider />
      <About />
      <Room />
      <WeddingLawnAndConferenceHall/>
      <Gallery />
      <NearbyAttract/>
      <Facilities/>
      <Location/>
      <Testimonials/>
      <NearbyCities/>
      <Contact />
      <Footer />

      
    </div>
  );
}

export default App;
